import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import {Panel, Button, Modal,OverlayTrigger,Popover  } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {recommendedforyou}  from '../../../actions';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';


const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

class Recommended extends Component{
	constructor(props){
		super(props);
		this.state={},
		this.state={
			tot_data:[],
			product_offers:[],
			seed_offers:[],
			offers:[],
			recent:[],
			suggetions:[],
			pro_recommended:[],
			ad_assist_modal:false,
			ad_asst_confirm_modal:false,
			assist_data:[],
			queries:[],
		}
		this.getOffers=this.getOffers.bind(this);
		this.close=this.close.bind(this);
		this.submitAdAssistData=this.submitAdAssistData.bind(this);
	}
	componentDidMount()
	{
		this.getOffers();
	}
    componentWillMount(){
		this.props.recommendedforyou();
		if(this.props.recommended.suggetions)
		{
					this.setState({
						suggetions: this.props.recommended.suggetions,
					})			
		}		
    }
	getOffers()
	{
		var data1={from:'mobile_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getOffers',
			success:function(data)
			{
				if(data.status==='available')
				{
					this.setState({
						tot_data:data,
						product_offers:data.product_offers,
						seed_offers:data.seed_offers,
						offers:data.offers,
					});
					setTimeout(function(){ $('.promo_truck_img').show(); }, 100);
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	getAdAssistModal()
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('adassist_status','1');
			browserHistory.push('/login');
		}
		else
		{
			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
			var data1={from:'mobile_web',id:uid,pid:'',token:localStorage.getItem('token'),source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'checkaskExpert',
				success:function(data)
				{
					if(data.status==='success' && data.proceed===1)
					{
						this.setState({
							ad_assist_modal:!this.state.ad_assist_modal,
							assist_data:data,
							queries:data.queries
						});
						localStorage.removeItem('adassist_status');
					}
					if(data.status==='success' && data.proceed===0)
					{
						this.setState({
							ad_asst_confirm_modal:true,
							ad_asst_confirm_message:data.msg,
						});
						localStorage.removeItem('adassist_status');
					}
				}.bind(this),
				error:function(err)
				{

				}
			})
		}
	}
	close()
	{
		this.setState({
			ad_assist_modal:false,
			ad_asst_confirm_modal:false,
		});
	}
	setAdTime(val)
	{
		this.setState({
			ad_asst_time:val,
			time_err_status:false,
			time_err_msg:'',
		})
	}
	submitAdAssistData(event)
	{
		event.preventDefault();
		var error_flag=false;
		var q_id=$('#ad-sel-question').val();
		if(q_id == 1){
			$('#ad-sel-question').css("color", "red");
			$('#ad-sel-question option').css("color", "#666");
			error_flag=true;
		}else{
			$('#ad-sel-question').css("color", "#666");
			$('#ad-sel-question option').css("color", "#666");
			error_flag=false;			
		}
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		var ad_time=this.state.ad_asst_time ? this.state.ad_asst_time : '0';
		if(ad_time == '0'){
					console.log("dv;slfjlkfr");
			error_flag =true;
			this.setState({
				time_err_status:true,
				time_err_msg:'* Required',
			})						
		}
		console.log(error_flag);
		if(!error_flag)
		{
			var data1={from:'mobile_web',id:uid,token:localStorage.token,pid:'',time:ad_time,desc:'',source:source,campaign:campaign,url_id:url_id,selectedQue:q_id};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'askExpert',
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							ad_assist_modal:false,
							ad_asst_confirm_message:data.message,
							ad_asst_confirm_modal:true,
						});

					}
					else
					{
						this.setState({
							ad_assist_modal:false,
							// ad_asst_confirm_message:data.message,
						});
					}
				}.bind(this),
				error:function(err)
				{

				}
			})
		}		
	}			
	render()
	{

	$(document).off('change', '#ad-sel-question');
	$(document).on('change','#ad-sel-question',function(){
		$('#ad-sel-question').css("color", "#666");
		$('#ad-sel-question option').css("color", "#666");
	});

		const params = {
	      paginationClickable: true,
	      spaceBetween: 10,
	      slidesPerView: 1.8,
	      parallax: true,
	      parallaxEl: {
	        el: '.parallax-bg',
	        value: '-23%'
	      },
	      observer: true,
		  rebuildOnUpdate: true
		  // centeredSlides: true,
	    }	
const recommended = this.props.recommended.suggetions;
if(this.props.recommended.suggetions)
{

	var pro_recommended = recommended.map(function(product, index) { 
		return (
	        	<Link className="mob_rec_item" href={product.redirect_url}>
	              <div className="mob_rec_product_ofer_icon">
	                <img src={product.logo} alt="" />
	              </div>
	              <div className="mob_rec_product_cntnt">
	                {product.product ? <h5 className="mob_rec_product_title">{product.product}</h5> : <h5>&nbsp;</h5>}
	                {product.mrp ? <h6 className="mob_rec_product_desc">MRP &#x20B9;{product.mrp}</h6> : <h6>&nbsp;</h6>}
	              </div>
	          </Link>


			   );

	 });


}





		var product_offers = this.state.product_offers.map(function(product, index) {
	      return (
	        	<Link className={"new_promo_item promo_road_img2"} to={"/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.product_id+"/"+product.deal_id} >
	        	{/*<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={"/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.product_id+"/"+product.deal_id} >*/}
		            <div className="promo_swipe_img">
		            <div className="raod_img"> <img className="img" src="https://aquadeals.in/admin/assets/images/web_imgs/road_0.png" alt="" title="" />
 <span className="promo_swipe_img_item">
 <img src={product.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : product.img} alt="" />
 </span>
		             </div>
	                   <div className="btm_swp">
	                    {product.title ? <h5 className="promo_gen_title">{product.title}</h5> : <h5 className="promo_gen_title">&nbsp;</h5>}
	                    {product.desc ? <h6 className="gen_desc">{product.desc}</h6> : <h6 className="gen_desc">&nbsp;</h6>}
	                    </div>
	                </div>
		        </Link>
	      	)
	    });
	    var seed_offers = this.state.seed_offers.map(function(seed, index) {
	        return (
	          	<Link className={"new_promo_item promo_road_img2"} to={"/sdetails/"+seed.url_title+"/"+seed.deal_id}>
	          	{/*<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={"/sdetails/"+seed.url_title+"/"+seed.deal_id}>*/}
	                <div className="promo_swipe_img">
	                 <div className="raod_img"> <img className="img" src="https://aquadeals.in/admin/assets/images/web_imgs/road_0.png" alt="" title="" />
	                    <span className="promo_swipe_img_item"><img src={seed.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : seed.img} alt="" /></span>
	                   	</div>
	                   	<div className="btm_swp">
	                    {seed.title ? <h5 className="promo_gen_title">{seed.title}</h5> : <h5 className="promo_gen_title">&nbsp;</h5>}
	                    {seed.desc ? <h6 className="gen_desc">{seed.desc}</h6> : <h6 className="gen_desc">&nbsp;</h6>}
	                    </div>
	                </div>
	            </Link>
	        )
	    });  
	    var offers = this.state.offers.map(function(offer, index) {
	        return (
	          	<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={'/offer/'+offer.id+"/details"}> 
	          	{/*<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={'/offer/'+offer.id+"/details"}> */}
	                <div className="promo_swipe_img">
	                 <div className="raod_img"> <img className="img" src="https://aquadeals.in/admin/assets/images/web_imgs/road_0.png" alt="" title="" />
	                    <span className="promo_swipe_img_item"><img src={offer.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : offer.img} alt="" /></span>
	                   	</div>
	                   	<div className="btm_swp">
	                    {offer.title ? <h5 className="promo_gen_title">{offer.title}</h5> : <h5 className="promo_gen_title">&nbsp;</h5>}
	                    {offer.desc ? <h6 className="gen_desc">{offer.desc}</h6> : <h6 className="gen_desc">&nbsp;</h6>}
	                    </div>
	                </div>      
	            </Link>
	          )
	    });
	    $('body').css('background-color','#fff');

		return(
			<div>
			{((this.props.recommended.ad_assist_flag == 1) && (this.props.isLoading) ) ? 
				<div style={{backgroundColor:'#fff',marginTop:'10px',marginBottom:'10px',paddingTop:'10px',paddingBottom:'10px'}} className="mob_rec_block">
						<h4 className="stores_title">AD ASSIST</h4>
						<img  src={baseAssets+"/icons/"+this.props.recommended.ad_assist_banner}  alt="" onClick={()=>{this.getAdAssistModal()}} />	
				</div>		
			 : '' }
            
			{((this.props.recommended.suggetions != '') && (this.props.isLoading) ) ? 

				<div style={{backgroundColor:'#fff',marginTop:'10px',marginBottom:'10px',paddingTop:'10px',paddingBottom:'10px'}} className="mob_rec_block">
					<h4 className="stores_title">RECOMMENDED FOR YOU</h4>
							<Swiper {...params} key={this.state.suggetions}> 
								{pro_recommended}
							</Swiper>
			    </div>
				: 
				''}
			  	<Modal className="ad_asst_modalbox" show={this.state.ad_assist_modal} onHide={this.close} id="ad_assist_home">
			  		<Modal.Body>
			  			{/*<h3 className="adassist_title">AD ASSIST</h3>
			  			<p><span className="orng_clr">Brand: </span> </p>
			  			<p><span className="orng_clr">Product: </span> </p>
			  			<p className="orng_clr">Available time for call back? </p>
			  			<form onSubmit={this.submitAdAssistData}>
				  			<div className="ad_asst_time_blk">
				  				<span >9am - 12pm</span>
				  				<span >12pm - 3pm</span>
				  				<span >3pm - 5pm</span>
				  			</div>
							<p className="orng_clr">Description</p>
							<textArea ref="ad_asst_desc" placeholder="What would you like us to assist you with ?" className="ad_asst_desc" rows={5}/>
							<div className="ad_asst_submit_blk">
								<button type="button" onClick={this.close}>CANCEL</button>
								<button type="submit">HELP!</button>
							</div>
						</form>
						*/}
						<section id="assets_cnt_block">
								<span onClick={this.close}><Icon
				                    name='close'
				                    font='SimpleLineIcons'
				                    color='#fff'
				                    size={16}
				                    style={{position:'absolute',right:'10px',top:'8px'}}
				                  />
				                </span>
							<img  src={require('./../../../assets/images/ad_assest_pop_icon.png')}  alt="" />					
							<p>Please submit the details, one of our experts will respond shortly.</p>
					      <div className="aqua-txt-block">
						      <select id="ad-sel-question">
						        {this.state.queries.map((option) => <option key={option.id} value={option.id}>{option.question}</option>)}
						      </select>
						  	  <h6>Best time to contact:  {this.state.time_err_status ? <span style={{color:'red',fontSize:'10px'}}>{this.state.time_err_msg}</span> : ''}</h6>
		  			{/*<form onSubmit={this.submitAdAssistData}>
			  			<div className="ad_asst_time_blk">
			  				<span className={this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(1)}}>9am - 12pm</span>
			  				<span className={this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(2)}}>12pm - 3pm</span>
			  				<span className={this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(3)}}>3pm - 5pm</span>
			  			</div>
							<div className="ad_asst_submit_blk">
								<button type="button" onClick={this.close}>CANCEL</button>
								<button type="submit">HELP!</button>
							</div>
					</form>*/}		
		  			<form onSubmit={this.submitAdAssistData}>
			  			<div className="ad_asst_time_blk">
			  				<span className={this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(1)}}>9am - 12pm</span>
			  				<span className={this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(2)}}>12pm - 3pm</span>
			  				<span className={this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(3)}}>3pm - 5pm</span>
			  			</div>
						<div className="ad_asst_submit_blk">
							{/*<button type="button" onClick={this.close}>CANCEL</button>*/}
							<button type="submit">SCHEDULE CALL</button>
						</div>
					</form>								  	            
					      </div>
						</section>
			  		</Modal.Body>
			  	</Modal>
			  	<Modal className="mob_reqbestprice"  show={this.state.ad_asst_confirm_modal} onHide={this.close}  >
					<Modal.Body>
						{this.state.ad_asst_confirm_message}
						<a onClick={this.close} className="req_conf_ok_btn">OK</a>
			  		</Modal.Body>
			  	</Modal>			  				  					
			</div>
		);	    	


	}
}

function mapStateToProps(state){
    return {
 		recommended: state.posts.recommended,
 		isLoading:state.posts.isLoading
    }
}

function mapDispatchToProps(dispatch) {
    return {
        recommendedforyou: bindActionCreators(recommendedforyou, dispatch)
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(Recommended);


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Promotions/Recommended.js
 **/